import CancelUpdateProfile from './cancel_update_profile';

export default class CancelUpdateEmailAddress extends CancelUpdateProfile {}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_profile/cancel_update_email_address.js